
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class CardSection extends Vue {
    @Prop({ type: Boolean, default: false }) readonly borderBottom!: boolean;
    @Prop({ type: Boolean, default: false }) readonly borderTop!: boolean;

    get classes() {
      return {
        ["py-4"]: true,
        ["border-b border-primary-color"]: this.borderBottom,
        ["border-t border-primary-color"]: this.borderTop,
      }
    }

  }
